import { sanitize } from '../../commonInfra/utils/Sanitize';
import { TextileHelper } from '../helpers/TextileHelper';
import { Module } from '../Module';

interface TextileScope extends ng.IScope {
  tbTextile: string;
  removeTrailingImage: boolean;
}

// A directive for formatting textile content.
Module.instance().directive('tbTextile', <any[]>[
  () => {
    return {
      restrict: 'A',
      scope: {
        tbTextile: '<',
        removeTrailingImage: '<',
      },
      link: (scope: TextileScope, element: JQuery) => {
        element.addClass('tb-textile tb-enable-selection');
        scope.$watch('tbTextile', (newVal: string) => {
          const text = scope.removeTrailingImage ? newVal.replace(TextileHelper.TRAILING_IMAGE, '') : newVal;
          const html = TextileHelper.getSanitizedHtmlFromTextile(text, sanitize);
          if (html !== null) {
            element.html(html);
            element.find('a').not('[target]').attr('target', '_blank');
          } else {
            element.text(newVal);
          }
        });
      }
    };
  }
]);
